import React, { useState } from 'react';

import { Grid, Typography, TextField, Box } from '@mui/material';
function JobCardSignatures(props) {
  const mltsEmployee = useState(props.mltsEmployee);

  return (
    <>
      <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
        <Typography variant='h6' fontWeight='700' textTransform='uppercase'>
          This certifies that I have personally checked the work completed and
          am satisfied with it.
        </Typography>
      </Grid>
      <Grid item xs={6} md={6} style={{ textAlign: 'center' }}>
        <Box
          variant='h6'
          fontWeight='700'
          textTransform='uppercase'
          alignItems='center'
          sx={{
            display: 'block',
            margin: '0 auto',
            border: 'solid 2px black',
            minHeight: '180px',
            maxHeight: '180px',
            minWidth: '300px',
            maxWidth: '300px',
          }}
        >
          <Typography variant='h6' fontWeight='700' sx={{ color: 'pink' }}>
            Company Stamp
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} md={12} pr={12} style={{ textAlign: 'left' }}>
        <Typography variant='h6' fontWeight='700'>
          Customer Approval:
        </Typography>
      </Grid>

      <Grid
        item
        border={'grey solid 1px'}
        // xs={12}
        md={3}
        sx={{ '@media print': { width: '25%' }, width: '100%' }}
        style={{
          textAlign: 'left',
          // borderLeft: 'none',
        }}
      >
        <TextField
          disabled
          className='input-print-style border-bottom'
          size='small'
          fullWidth
        />
        <Typography
          fontWeight='700'
          sx={{ borderTop: 'black solid 2px !important' }}
        >
          Name & Surname (Customer)
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={12}
        md={3}
        sx={{ '@media print': { width: '25%' }, width: '100%' }}
        style={{
          textAlign: 'left',
          // borderLeft: 'none',
        }}
      >
        <TextField
          disabled
          className='input-print-style border-bottom'
          size='small'
          fullWidth
        />
        <Typography
          fontWeight='700'
          sx={{ borderTop: 'black solid 2px !important' }}
        >
          Signature (Customer)
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={12}
        md={3}
        sx={{ '@media print': { width: '25%' }, width: '100%' }}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
        }}
      >
        <TextField
          fontWeight='400'
          // height={40}
          size='small'
          borderBottom='#bdbdbd solid 1px'
          value={mltsEmployee[0]}
          sx={{
            display: 'flex',
            alignItems: 'left',
            '& fieldset': { border: 'none' },
          }}
        />

        <Typography
          fontWeight='700'
          sx={{ borderTop: 'black solid 2px !important' }}
        >
          MLT Employee
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={12}
        md={3}
        sx={{ '@media print': { width: '25%' }, width: '100%' }}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
        }}
      >
        <TextField
          disabled
          className='input-print-style border-bottom'
          size='small'
          // height={40}
          fullWidth
        />
        <Typography
          fontWeight='700'
          sx={{ borderTop: 'black solid 2px !important' }}
        >
          MLT Employee Signature
        </Typography>
      </Grid>
    </>
  );
}

export default JobCardSignatures;
